import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
// const BASE_URL = "https://hb40wwcn-8000.inc1.devtunnels.ms";

// Super Admin Login
export const loginSuperAdmin = async (credentials) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/SuperAdmin_login/login_SuperAdmin/`,
      credentials
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Admin Login
export const loginAdmin = async (credentials) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/Admin_Login/login_Admin/`,
      credentials
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Employee Login
export const loginEmployee = async (credentials) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/Employee_login/login_Employee/`,
      credentials
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Reset Super Admin Password
export const resetSuperAdminPassword = async (data, resetToken) => {
  try {
    if (!resetToken) {
      throw new Error("Reset token is missing or invalid.");
    }

    const headers = {
      Authorization: `Bearer ${resetToken}`,
    };

    const response = await axios.post(
      `${BASE_URL}/SuperAdmin_login/first_time_password_reset/`,
      data,
      { headers }
    );

    return response.data;
  } catch (error) {
    console.log(error.response.data, "erro");

    throw error.response ? error.response.data : error.message;
  }
};

export const resetAdminPassword = async (data, resetToken) => {
  try {
    if (!resetToken) {
      throw new Error("Reset token is missing or invalid.");
    }

    const headers = {
      Authorization: `Bearer ${resetToken}`,
    };

    const response = await axios.post(
      `${BASE_URL}/Admin_Login/first_time_password_reset_Admin/`, // Updated API endpoint
      data,
      { headers }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    ); // Debugging
    throw error.response ? error.response.data : error.message;
  }
};
export const resetEmployeePassword = async (data, resetToken) => {
  try {
    if (!resetToken) {
      throw new Error("Reset token is missing or invalid.");
    }

    const headers = {
      Authorization: `Bearer ${resetToken}`,
    };

    const response = await axios.post(
      `${BASE_URL}/Employee_login/first_time_password_reset_Employee/`, // Updated API endpoint
      data,
      { headers }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    ); // Debugging
    throw error.response ? error.response.data : error.message;
  }
};

// LoginAuthService.jsx
// In LoginAuthService.jsx update the forgotPassword function
export const forgotPassword = async (role, email) => {
  try {
    const endpointMap = {
      superadmin: `${BASE_URL}/SuperAdmin_login/forget_password_SuperAdmin/`,
      admin: `${BASE_URL}/Admin_Login/forget_password_Admin/`,
      employee: `${BASE_URL}/Employee_login/forget_password_Employee/`,
    };

    // Create payload based on role
    const payload = {
      superadmin: { a_email: email },
      admin: { a_email: email }, // or admin-specific field if different
      employee: { e_email: email },
    }[role];

    const response = await axios.post(endpointMap[role], payload);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// LoginAuthService.jsx
const token = localStorage.getItem("token");

export const forgotResetSuperAdminPassword = async (data, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/SuperAdmin_login/reset_password_SuperAdmin/${token}/`,
      data
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const forgotResetAdminPassword = async (data, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/Admin_Login/reset_password_Admin/${token}/`,
      data
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const forgotResetEmployeePassword = async (data, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/Employee_login/reset_password_Employee/${token}/`,
      data
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// export const verifyOtp = async (otp, resetToken) => {
//   try {
//     const headers = {
//       Authorization: `Bearer ${resetToken}`,
//     };
//     const response = await axios.post(
//       `${BASE_URL}/SuperAdmin_login/verify-otp/`, // Update with your actual endpoint
//       { otp },
//       { headers }
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response ? error.response.data : error.message;
//   }
// };

// In LoginAuthService.jsx
export const trustThisDevice = async (otp, trustDevice, accessToken, role) => {
  try {
    const headers = {
      Authorization: `Bearer ${accessToken}`,
    };

    // Determine endpoint based on role
    let endpoint;
    switch (role.toLowerCase()) {
      case "superadmin":
        endpoint = "SuperAdmin_login/verify_otp/";
        break;
      case "admin":
        endpoint = "Admin_Login/verify_otp/";
        break;
      case "employee":
        endpoint = "Employee_login/verify_otp/";
        break;
      default:
        throw new Error("Invalid user role");
    }

    const response = await axios.post(
      `${BASE_URL}/${endpoint}`,
      {
        otp: otp,
        trust_device: trustDevice,
      },
      { headers }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
